module.exports = __webpack_public_path__ + "img/Masterclass_Kc.d3b03725.png";